<template>
  <div>
    <model-table
      :collection="navigations"
      :columns="[
        { field: 'id' },
        { field: 'title' },
        { field: 'category' },
        { name: 'Visibility', field: navigation => navigation.displayIcons, component: 'icons' },
        { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
        { name: 'actions', align: 'right' }
      ]"
      :orderable="true"
      :has-library="!currentCircuit.isLibrary"
      :library-collection="navigationLibrary"
      :library-columns="[
        { field: 'title' },
        { name: 'Visibility', field: navigation => navigation.displayIcons, component: 'icons' },
        { field: 'mobileMenuLabel' },
      ]"
      :link-filter="libraryFilterFunction"
    >
      <navigation-form />
    </model-table>
  </div>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import NavigationForm from 'src/modules/admin/navigation/NavigationForm.vue'

export default {
  name: 'NavigationTable',
  components: {
    ModelTable,
    NavigationForm
  },
  configuration: ['currentCircuit'],
  models: {
    navigations: {
      page: true,
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    navigationLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    view (bor) {
      bor.view()
    },
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
